export default{ // Used for the News’ Homepage，adjust the order of newsItems to match the order of the news on the website
data() {
    return {
    cn:{
        news_title: '新闻中心',
        topNews: [
          {
            id: 1,
            image: require('@/assets/img/News/NewsHomePage/008-VRParkPageWallpaper.png'),
            title: `置顶新闻：云翰虹章携手匈牙利VR Vidámpark团队，共拓中国VR主题公园市场`
            ,
            description: `云翰虹章与匈牙利团队合作，推出VR主题公园项目`,
            DetailPageName: "008-VRParkPage"
          },
        ],
      newsItems: [
        {
          id: 1,
          image: require('@/assets/img/News/NewsHomePage/001-Logo_news_edited.jpg'),
          title: '宁波云翰虹章信息科技有限责任公司正式成立',
          description: '2022年6月22日成立的宁波云翰虹章致力于用技术创造独特价值。',
          DetailPageName: "001-CompanyEstablishedPage"
        },
        {
          id: 2,
          image: require('@/assets/img/News/NewsHomePage/002-CeramsiteFactoryPageWallpaper_news_edited.png'),
          title: '云翰虹章开启新篇章：CG动画展示陶粒板材工厂生产流程',
          description: '2022年8月，云翰虹章制作的陶粒生产流程CG动画正式完成，首个重大项目顺利结项',
          DetailPageName: "002-CeramsiteFactoryPage"
        },
        {
          id: 3,
          image: require('@/assets/img/News/NewsHomePage/003-XiangShanPageWallpaper_news_edited.jpg'),
          title: '云翰虹章与象山影视城达成战略合作，共同推进数字化文旅发展',
          description: '云翰虹章与象山影视城达成合作，将为其提供技术支持',
          DetailPageName: "003-XiangShanPage"
        },
        {
          id: 4,
          image: require('@/assets/img/News/NewsHomePage/004-LightShowPageWallpaper_news_edited.png'),
          title: '象山影视城“唐宋奇妙夜”文化夜游活动火爆开启，云翰虹章技术支持助力创新体验',
          description: '云翰虹章为“唐宋奇妙夜”的灯光投影提供了配套的技术服务',
          DetailPageName: "004-LightShowPage"
        },
        {
          id: 5,
          image: require('@/assets/img/News/NewsHomePage/005-IEBPageWallpaper_news_edited.png'),
          title: '云翰虹章正式入驻宁波诺丁汉大学国际创新创业产业园',
          description: '2023年5月1日，云翰虹章正式入驻宁波诺丁汉大学的国际创新创业产业园的创新创业大楼。',
          DetailPageName: "005-IEBPage"
        },
        {
          id: 6,
          image: require('@/assets/img/News/NewsHomePage/006-cover.png'),
          title: '云翰虹章与顾问徐宁宁启动联合项目-VR音乐游戏',
          description: '推动VR技术在音乐领域的广泛应用，开辟全新的发展前景。',
          DetailPageName: "006-VRMusicPage"
        },
        {
          id: 7,
          image: require('@/assets/img/News/NewsHomePage/007-InnovationEntrepreneurshipPageWallpaper_news_edited.png'),
          title: '中东欧青年创新创业大赛在宁波成功举办——云翰虹章团队分享创业成果',
          description: '云翰虹章团队在中东欧青年创新创业大赛上分享自己的创业经历',
          DetailPageName: "007-InnovationEntrepreneurshipPage"
        },
        {
          id: 8,
          image: require('@/assets/img/News/NewsHomePage/008-VRParkPageWallpaper.png'),
          title: '云翰虹章携手匈牙利VR Vidámpark团队，共拓中国VR主题公园市场',
          description: '云翰虹章与匈牙利团队合作，推出VR主题公园项目',
          DetailPageName: "008-VRParkPage"
        },
        {
          id: 9,
          image: require('@/assets/img/News/NewsHomePage/009-cover.jpg'),
          title: '云翰虹章出席诺丁汉大学全球创新创业生态大会',
          description: '与VR Vidámpark团队合作再升级，深化国际交流合作',
          DetailPageName: "009-GlobalPitch2024"
        },
        {
          id: 10,
          image: require('@/assets/img/News/NewsHomePage/010-cover.jpeg'),
          title: '宁波市区首家VR LBE体验店“童话之城”开业',
          description: '云翰虹章携手VR Vidámpark、宁波科学探索中心打造的全新力作',
          DetailPageName: "010-VRParkFairyTale"
        },
        {
          id: 11,
          image: require('@/assets/img/News/NewsHomePage/011-cover.jpg'),
          title: '十一金秋，奥乐奇境VR乐园正式开园',
          description: '携手VR Vidámpark、宁波方特团队，不一样的VR体验',
          DetailPageName: "011-VRParkOrcaBeat"
        },
        {
          id: 12,
          image: require('@/assets/img/News/NewsHomePage/012-cover.jpg'),
          title: '云翰虹章大空间VR项目在“海丝文旅大展”展出啦！',
          description: '云翰虹章技术团队制作的VR内容首秀',
          DetailPageName: "012-CulturalExhibition"
        },
      ],
    }
    }
  }
};